var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5968,
    cy: 7.90625,
    rx: 8.11765,
    ry: 7.90625,
    fill: "#9D99F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8312 23.5C17.1053 23.5 21.4489 19.3257 21.4489 14.0938C21.4489 8.86176 17.1053 4.6875 11.8312 4.6875C6.55709 4.6875 2.21356 8.86176 2.21356 14.0938C2.21356 19.3257 6.55709 23.5 11.8312 23.5Z",
    fill: "#4F46E5",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4782 10.3125L12.7659 12.944L15.7134 14.0938L12.7659 15.2435L11.4782 17.875L10.1904 15.2435L7.24286 14.0938L10.1904 12.944L11.4782 10.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptIcon);
export default __webpack_public_path__ + "static/media/prompt-icon.2302e2b7804b4cb63361c51bafe9b7b5.svg";
export { ForwardRef as ReactComponent };